<template>
  <div class="line-item-v2">
    <div class="d-flex mb-3 align-center justify-space-between flex-wrap">
      <div class="d-flex align-center">
        <v-autocomplete
          hide-details
          v-model.trim="product_type"
          :items="productTypeOptions"
          clearable
          v-on:click:clear="product_type = null"
          style="max-width: 220px !important"
          dense
          flat
          filled
          placeholder="Select product / part"
          item-color="cyan"
          class="mr-2 custom-boder-color"
          color="cyan"
          solo
          :menu-props="{ offsetY: true }"
          v-on:change="open_dialog($event, 'top')"
          item-value="value"
          item-text="text"
        >
        </v-autocomplete>
      </div>
    </div>

    <v-card
      flat
      outlined
      class="rounded-lg border-slate bg-white overflow-hidden mb-4 shadow-0"
    >
      <div class="d-flex grey lighten-4 border-bottom align-center px-3 py-2">
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-center d-flex align-center justify-center"
          style="width: 4%"
        >
          #
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-left px-2 d-flex align-center"
          style="width: 48%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-package-variant-closed</v-icon
          >
          Product / Part
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 12%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-cube-outline</v-icon
          >
          Available Qty.
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 14%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-tune-vertical</v-icon
          >
          Type
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 12%"
        >
          <v-icon small color="cyan darken-2" class="mr-1">mdi-numeric</v-icon>
          Adjusted Qty.
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase px-2 d-flex align-center justify-center text-center"
          style="width: 10%"
        >
          <v-icon small color="cyan darken-2" class="mr-1"
            >mdi-checkbox-marked-circle-outline</v-icon
          >
          Updated Qty.
        </div>
        <div
          class="color-custom-blue font-weight-700 font-size-14 text-uppercase text-center"
          style="width: 4%"
        ></div>
      </div>

      <Draggable
        tag="ul"
        v-model="selected_line_items"
        class="line-item-drag-group mb-0 pa-0"
        draggable=".line-item-drag"
        handle=".line-item-drag-icon"
        ghost-class="line-item-ghost"
        :key="`line-item-img-${dialog_key}`"
        animation="200"
        group="line-item-drag"
        v-on:start="drag = true"
        v-on:end="drag = false"
        v-on:change="emit_values()"
      >
        <transition-group type="transition" :name="!drag ? 'flip-list' : null">
          <li
            v-for="(row, index) in selected_line_items"
            class="line-item-drag border-bottom border-slate-100 hover:bg-slate-50 transition-fast pa-0"
            :key="`line-item-drag-${index}`"
          >
            <div
              :id="`line-item-drag-${index}`"
              class="d-flex align-center py-2 px-3"
            >
              <div class="font-weight-600 text-center" style="width: 4%">
                {{ index + 1 }}
              </div>
              <div class="text-left px-2" style="width: 48%">
                <div class="d-flex align-center">
                  <v-avatar size="32" class="rounded-lg border">
                    <img
                      v-if="row?.image?.url"
                      :src="row?.image?.url"
                      :alt="row?.image?.name"
                    />
                    <img v-else :src="$defaultImage" />
                  </v-avatar>
                  <div style="width: 100%" class="ml-2">
                    <v-text-field
                      readonly
                      v-model.trim="row.product"
                      class="line-item-header-text px-0"
                      placeholder="Line Item"
                      dense
                      filled
                      solo
                      v-on:change="changeName(index, row.product)"
                      flat
                      hide-details
                      color="cyan"
                    >
                      <template v-slot:append>
                        <v-chip
                          :key="`product-type-${row?.index}-${index}-${row?.product_id}`"
                          color="cyan white--text"
                          label
                          small
                          class="lip-type text-uppercase font-weight-600"
                          :class="{
                            product: row?.product_type == 'goods',
                            parts: row?.product_type == 'parts',
                          }"
                        >
                          {{ row?.product_type === "parts" ? "Part" : "Product" }}
                        </v-chip>
                        <v-chip
                          :key="`product-isSerialized-${row?.index}-${index}-${row?.product_id}`"
                          :color="
                            row?.isSerialized
                              ? 'green darken-1'
                              : 'red lighten-1'
                          "
                          style="max-width: 110px !important"
                          class="ml-2 font-weight-600"
                          small
                          label
                          text-color="white"
                        >
                          {{
                            row?.isSerialized ? "Serialized" : "Non-serialized"
                          }}
                        </v-chip>
                        <v-tooltip
                          top
                          content-class="custom-top-tooltip"
                          :key="`product-serial_numbers-${row?.index}-${index}-${row?.product_id}`"
                          v-if="row?.isSerialized > 0"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip
                              v-bind="attrs"
                              v-on="on"
                              color="cyan darken-2"
                              label
                              small
                              style="width: 28px; margin-left: 5px"
                              v-on:click="
                                update_serial_numbers_dialog(
                                  row,
                                  index,
                                  row.serial_numbers
                                )
                              "
                              class="text-uppercase font-weight-600 white--text"
                            >
                              <v-icon small>mdi-cog</v-icon>
                            </v-chip>
                          </template>
                          <span>Manage Serial Numbers</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </div>
                </div>
                <div
                  class="d-flex align-center flex-wrap ml-0 mt-1"
                  v-if="row?.barcode"
                >
                  <v-chip
                    label
                    color="cyan darken-3"
                    outlined
                    x-small
                    class="font-weight-700 mr-2"
                    >{{ row.barcode }}</v-chip
                  >
                </div>
              </div>
              <div class="text-center px-2" style="width: 12%">
                <v-text-field
                  class="line-item-header-text px-0 d-none"
                  placeholder="Available Qty."
                  dense
                  filled
                  solo
                  type="number"
                  readonly
                  v-model="row.initial_stock"
                  flat
                  color="cyan"
                  v-on:keypress="isNumber($event, row.initial_stock)"
                />
                <span class="font-weight-700 font-size-15 color-custom-blue">{{
                  row.initial_stock
                }}</span>
              </div>
              <div class="text-center px-2" style="width: 14%">
                <v-autocomplete
                  :menu-props="{ offsetY: true }"
                  dense
                  filled
                  color="cyan"
                  item-color="cyan"
                  :items="calculation_type"
                  placeholder="Type"
                  solo
                  flat
                  hide-details
                  item-text="text"
                  item-value="id"
                  return-object
                  :class="`pr-0 width-100 ${
                    row?.calculation_type ? '' : 'error--text'
                  }`"
                  :style="
                    row?.calculation_type
                      ? row.calculation_type.id == 1
                        ? 'background-color: rgb(248, 201, 201) !important;'
                        : 'background-color: rgb(220, 246, 220) !important;'
                      : ''
                  "
                  v-model.trim="row.calculation_type"
                  @change="
                    adjustedquantitycalculation(row, index, 'calculation_type')
                  "
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No Type Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </div>
              <div class="text-center px-2" style="width: 12%">
                <v-text-field
                  :readonly="row.calculation_type ? false : true"
                  :class="`px-0 ${
                    row?.adjusted_quantity > 0 ? '' : 'error--text'
                  }`"
                  placeholder="Adjusted Qty."
                  dense
                  filled
                  solo
                  flat
                  hide-details
                  type="number"
                  ref="adjustedQuantity"
                  v-model="row.adjusted_quantity"
                  v-on:keypress="isNumber($event)"
                  @paste="handleQuantityPaste($event, row, index)"
                  color="cyan"
                  @input="adjustedquantitycalculation(row, index)"
                >
                  <template #prepend-inner>
                    <v-icon :color="getIconColor(row)" small>
                      {{ getIconName(row) }}
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
              <div class="text-center px-2" style="width: 10%">
                <v-text-field
                  class="line-item-header-text px-0 d-none"
                  placeholder="Updated Qty."
                  dense
                  filled
                  solo
                  flat
                  type="number"
                  v-model="row.total_qty"
                  v-on:keypress="isNumber($event)"
                  color="cyan"
                  readonly
                />
                <span class="font-weight-700 font-size-15 color-custom-blue">{{
                  row.total_qty
                }}</span>
              </div>
              <div class="font-weight-600 text-center" style="width: 4%">
                <v-btn
                  v-on:click="remove_row(index, row)"
                  icon
                  small
                  color="red lighten-1"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
              </div>
            </div>
          </li>
        </transition-group>
      </Draggable>
      <template v-if="!selected_line_items.length">
        <div class="pa-6 text-center">
          <v-icon color="slate-300" large class="mb-2"
            >mdi-package-variant-closed text-slate-300</v-icon
          >
          <p class="m-0 font-size-16 font-weight-500 text-slate-500">
            No line items added yet. Click Product or Part above to add items.
          </p>
        </div>
      </template>
    </v-card>

    <LineItemDialog
      :key="`line-item-dialog-${dialog_key}`"
      :product-type="product_type"
      :product-dialog="product_dialog"
      v-on:update-values="update_line_item($event)"
      v-on:close="(product_dialog = false), (module_type = null)"
    />
    <SerialNumber
      v-if="serial_number_dialog"
      :key="`product-new-serial-number-dialog-${dialog_key}`"
      :dialogStatus="serial_number_dialog"
      :serial-array="serial_number_array"
      :serial-object="serial_number_object"
      v-on:close:dialog="close_serial_number_dialog()"
      v-on:save="saveData($event)"
    >
    </SerialNumber>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Draggable from "vuedraggable";
import LineItemDialog from "@/view/pages/product/adjustment/AdjustmentItemDialog.vue";
import SerialNumber from "@/view/components/Serial-Number-Dialog.vue";
import { SET_LINE_ITEM } from "@/core/services/store/line.item.module";
import CommonMixin from "@/core/plugins/common-mixin.js";
import { ErrorEventBus, InitializeError, ClearEventBus } from "@/core/lib/message.lib";
import { cloneDeep } from "lodash";
import ObjectPath from "object-path";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);
export default {
  name: "line-item-v1",
  mixins: [CommonMixin],
  data() {
    return {
      calculation_type: [
        {
          id: 1,
          text: "Subtraction",
        },
        {
          id: 2,
          text: "Addition",
        },
      ],
      product_location: null,
      drag: false,
      module_type: null,
      numberIndex: -1,
      dialog_key: Number(new Date()),
      product_type: null,
      productTypeOptions: [
        {
          value: "goods",
          text: "Product",
          show: true,
        },
        {
          value: "parts",
          text: "Part",
          show: true,
        },
      ],
      product_dialog: false,
      selected_line_items: [],
      serial_number_dialog: false,
      serial_number_object: {},
      serial_number_array: [],
    };
  },
  props: {},
  watch: {},
  methods: {
    handleQuantityPaste(event, item, index) {
      if (!item.calculation_type || item.calculation_type.text !== "Addition") {
        return;
      }

      const pastedValue = event.clipboardData
        ? event.clipboardData.getData("text")
        : "";

      if (Number(pastedValue) <= 5000) return;

      event.preventDefault();
      item.adjusted_quantity = 5000;
      ErrorEventBus.$emit(
        "update:error",
        InitializeError("Addition quantity cannot be greater than 5000 serial numbers.")
      );
      this.adjustedquantitycalculation(item, index);
    },

    update_serial_numbers_dialog(row, index) {
      this.serial_number_object = row;
      this.serial_number_array = row?.serial_numbers;
      this.numberIndex = index;
      this.serial_number_dialog = true;
    },
    getIconColor(row) {
      if (!row?.calculation_type) return "";
      return row.calculation_type.id == 1 ? "red" : "green";
    },
    getIconName(row) {
      if (!row?.calculation_type) return "";
      return row.calculation_type.id == 1 ? "mdi-minus" : "mdi-plus";
    },
    adjustedquantitycalculation(item, index, calculation_type = null) {
      const available = Number(item.initial_stock) || 0;
      const adjusted = Number(item.adjusted_quantity) || 0;

      // Must have type selected
      if (!item.calculation_type || !item.calculation_type.text) return;

      const type = item.calculation_type.text;

      if (type === "Subtraction") {
        if (adjusted > available) {
          item.adjusted_quantity = available;
          this.$nextTick(() => {
            const fields = this.$refs.adjustedQuantity;
            const field = Array.isArray(fields) ? fields[index] : fields;
            const input = field && field.$el.querySelector("input");

            if (input && document.activeElement === input) {
              input.select();
            }
          });
        }
        item.total_qty = available - Number(item.adjusted_quantity || 0);
      }

      if (type === "Addition") {
        if (adjusted > 5000) {
          item.adjusted_quantity = 5000;
          ErrorEventBus.$emit(
            "update:error",
            InitializeError("Addition quantity cannot be greater than 5000 serial numbers.")
          );
        }
        item.total_qty = available + Number(item.adjusted_quantity || 0);
      }
      this.$set(this.selected_line_items, index, { ...item });
      this.$nextTick(() => {
        this.emit_values();
      });

      if (calculation_type && calculation_type == "calculation_type") {
        ObjectPath.set(
          this.selected_line_items,
          `${index}.adjust_serial_array`,
          []
        );
        this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items);
      }
    },
    saveData(param) {
      const qty_array = cloneDeep(param);
      ObjectPath.set(
        this.selected_line_items,
        `${this.numberIndex}.adjust_serial_array`,
        qty_array
      );
      this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items);
      this.close_serial_number_dialog();
    },
    close_serial_number_dialog() {
      this.serial_number_object = {};
      this.serial_number_array = [];
      this.numberIndex = -1;
      this.serial_number_dialog = false;
      this.$nextTick(() => {
        ClearEventBus.$emit("clear:error");
      });
    },

    update_line_item(param) {
      for (let item of param) {
        if (this.product_location == "top") {
          this.selected_line_items.unshift(item);
        } else {
          this.selected_line_items.push(item);
        }
      }
      this.$nextTick(() => {
        this.emit_values();
        this.product_dialog = false;
        this.product_type = null;
        this.product_location = null;
        this.module_type = null;
      });
    },

    changeName(index, row) {
      this.selected_line_items[index].product = row;
      this.$nextTick(() => {
        this.emit_values();
      });
    },

    emit_values() {
      this.$nextTick(() => {
        this.$store.dispatch(SET_LINE_ITEM, this.selected_line_items);
      });
    },

    open_dialog(param) {
      if (!param) {
        return false;
      }
      this.dialog_key = Number(new Date());
      this.product_type = param;
      this.product_dialog = true;
    },

    remove_row(index) {
      this.selected_line_items.splice(index, 1);
      this.emit_values();
    },
  },
  components: {
    Draggable,
    LineItemDialog,
    SerialNumber,
  },
  mounted() {},

  created() {},
  computed: {
    ...mapGetters([]),
  },
};
</script>
